import React from 'react'
import { Helmet } from 'react-helmet'

import { About, Projects, Contacts, Education, Experience, Landing, Navbar, Skills, Blog } from '../../components';
import { headerData } from '../../data/headerData';

function HomePage() {
    return (
        <div>
            <Helmet>
                <title>Dev-Safayet - Porfolio</title>
            </Helmet>

            <Navbar />
            <Landing />
            <About />
            {/* <Education /> */}
            <Skills />
            <Experience />
            <Projects />
            <Blog />
            <Contacts />
        </div>
    )
}

export default HomePage
